import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-odr',
  imports: [RouterModule],
  templateUrl: './odr.component.html',
  styleUrl: './odr.component.scss'
})
export class OdrComponent {

}
